export default class VisualCategory {
  constructor(context) {
    const parent = context.parentElement;
    const containsClass = parent.classList.contains(
      'commercial-module-spacing'
    );

    if (!containsClass) {
      parent.classList.add('commercial-module-spacing');
    }
  }
}
